import type { DiscountVoucher, TakeawayOption, Voucher } from '~/models';

import { useNuxtApp } from '#app';

const useVoucherStore = defineStore('customer-voucher', () => {
  const { $http } = useNuxtApp();

  const isValid = (discount: DiscountVoucher): boolean | string => {
    const cartStore = useCartStore();
    const takeawayType = cartStore.takeaway.type;

    if (
      discount.takeawayOptions &&
      !discount.takeawayOptions.includes(
        takeawayType.toUpperCase() as TakeawayOption
      )
    ) {
      return `This voucher is not available for ${takeawayType}`;
    }

    if (discount.products && discount.products.length > 0) {
      let hasValidItem = false;
      for (const item of cartStore.items) {
        const hasDiscount = discount.products.some(
          (product) => product.uuid === item.productUuid);
        if (hasDiscount) {
          hasValidItem = true;
          break;
        }
      }

      if (!hasValidItem) {
        return 'The voucher can not be applied for selected items';
      }
    }

    const minValue = discount.minimumOrderValue || 0;

    if (minValue === 0) {
      return true;
    }

    const minimumValueIsValid = discount && minValue <= cartStore.subtotal;

    const errorMessage = `This voucher requires a minimum value of € ${discount.minimumOrderValue} to be accepted`;

    return minimumValueIsValid || errorMessage;
  };

  const get = async (code: string, cartUuid: string): Promise<Voucher> => {
    const discount = await $http.discount.voucher({ voucherCode: code, cartUuid: cartUuid });

    return {
      discount,
      valid: isValid(discount)
    };
  };

  return {
    get,
    isValid
  };
});

export { useVoucherStore };
